export const locale = {
  addNewChartHint: 'Add new chart',
  addNewChart: 'CLICK HERE TO ADD A CHART'
};
